import React from "react";

const Section5 = () => {
  return (
    <section className="mx-auto py-12">
      <div className="flex flex-col lg:flex-row items-center justify-between gap-4 ">
        {/* Left Side - Stays on the left for large screens */}
        <div className="bg-gray-50 w-[95%] md:w-[90%] lg:w-2/5 min-h-[350px] md:min-h-auto shadow-xl rounded-r-2xl xl:rounded-r-2xl xl:rounded-l-none p-8 text-center flex flex-col justify-evenly self-start xl:self-auto">
          <div className="flex flex-col items-center justify-center m-auto gap-10 w-[50%]">
            <img src="../../../assets/smmLogo.webp" className="w-20 h-20" alt="" />
            <h2 className="text-4xl font-semibold text-gray-700">
              Social Media Marketing
            </h2>
          </div>
        </div>

        {/* Right Side - Stays on the right for large screens */}
        <div className="bg-gray-50 w-[95%] md:w-[90%] lg:w-3/5 min-h-[350px] md:min-h-auto flex flex-col justify-center gap-5 shadow-xl rounded-l-2xl xl:rounded-l-3xl xl:rounded-r-none p-8 xl:mr-0 self-end xl:self-auto">
          <div className="mt-6 w-full h-[5px] md:w-[20%] bg-red-500  "></div>
          <p className="text-lg text-gray-800">
            Mean3 took the social media marketing for Money Back Guarantee to
            new heights, delivering beyond expectations. We meticulously planned
            and executed the strategy, crafting captivating creative and running
            seamless ad campaigns across all major social media platforms. The
            outcome? An astounding 180 million views across social media,
            turning the hype into real results.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Section5;
